/**
 * Layout for public registration pages (logo header, narrow column).
 */

interface PublicShellProps {
  children: React.ReactNode;
}

export function PublicShell({ children }: PublicShellProps) {
  return (
    <div className="min-h-screen bg-muted/40 pb-16">
      <div className="mx-auto max-w-2xl space-y-4 px-4 pt-6">
        <div className="flex items-center justify-center gap-3">
          <img src="/LogoADDB.jpg" alt="Asambleas de Dios de Bolivia" className="size-12 rounded" />
          <p className="text-sm font-semibold leading-tight">
            Las Asambleas de Dios de Bolivia
            <span className="block text-xs font-normal text-muted-foreground">Inscripción a eventos</span>
          </p>
        </div>
        {children}
      </div>
    </div>
  );
}
